var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"gallery-section"},[(_vm.name)?_c('header',[_c('h2',[_vm._v(_vm._s(_vm.name))])]):_vm._e(),_c('section',{staticClass:"banners",class:_vm.section_classes},_vm._l((_vm.banners),function(banner){return _c('gallery-banner',{key:banner.basename(),attrs:{"banner":banner,"compact":_vm.compact}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }